import { createAction } from 'redux-actions';
import { normalize } from 'normalizr';
import { push } from '@lagunovsky/redux-react-router';
import { pick, pathOr } from 'ramda';
import { collection, onSnapshot, query, orderBy as ob, getDocs, where, doc, runTransaction, writeBatch, getDoc, updateDoc, addDoc, limit } from "firebase/firestore";

import { db } from '../firebase';
import boardgameSchema, { boardgames as boardgamesSchema } from '../schema/boardgame';
import { statistics as statisticsSchema } from '../schema/statistic';

import BggService from '../services/BggService';

const FETCH_VISIBLE_BOARDGAMES_REQUEST = 'FETCH_VISIBLE_BOARDGAMES_REQUEST';
const FETCH_VISIBLE_BOARDGAMES_SUCCESS = 'FETCH_VISIBLE_BOARDGAMES_SUCCESS';
const FETCH_VISIBLE_BOARDGAMES_FAILED = 'FETCH_VISIBLE_BOARDGAMES_FAILED';

const FETCH_BOARDGAMES_REQUEST = 'FETCH_BOARDGAMES_REQUEST';
const FETCH_BOARDGAMES_SUCCESS = 'FETCH_BOARDGAMES_SUCCESS';
const FETCH_BOARDGAMES_FAILED = 'FETCH_BOARDGAMES_FAILED';

const RESERVE_BOARDGAME_REQUEST = 'RESERVE_BOARDGAME_REQUEST';
const RESERVE_BOARDGAME_SUCCESS = 'RESERVE_BOARDGAME_SUCCESS';
const RESERVE_BOARDGAME_FAILED = 'RESERVE_BOARDGAME_FAILED';

const GET_BACK_BOARDGAME_REQUEST = 'GET_BACK_BOARDGAME_REQUEST';
const GET_BACK_BOARDGAME_SUCCESS = 'GET_BACK_BOARDGAME_SUCCESS';
const GET_BACK_BOARDGAME_FAILED = 'GET_BACK_BOARDGAME_FAILED';

const GET_BACK_ALL_BOARDGAMES_REQUEST = 'GET_BACK_ALL_BOARDGAMES_REQUEST';
const GET_BACK_ALL_BOARDGAMES_SUCCESS = 'GET_BACK_ALL_BOARDGAMES_SUCCESS';
const GET_BACK_ALL_BOARDGAMES_FAILED = 'GET_BACK_ALL_BOARDGAMES_FAILED';

const CREATE_BOARDGAME_REQUEST = 'CREATE_BOARDGAME_REQUEST';
const CREATE_BOARDGAME_SUCCESS = 'CREATE_BOARDGAME_SUCCESS';
const CREATE_BOARDGAME_FAILED = 'CREATE_BOARDGAME_FAILED';

const GET_BOARDGAME_REQUEST = 'GET_BOARDGAME_REQUEST';
const GET_BOARDGAME_SUCCESS = 'GET_BOARDGAME_SUCCESS';
const GET_BOARDGAME_FAILED = 'GET_BOARDGAME_FAILED';

const UPDATE_BOARDGAME_REQUEST = 'UPDATE_BOARDGAME_REQUEST';
const UPDATE_BOARDGAME_SUCCESS = 'UPDATE_BOARDGAME_SUCCESS';
const UPDATE_BOARDGAME_FAILED = 'UPDATE_BOARDGAME_FAILED';

const MARK_BOARDGAME_AS_SELECTION_REQUEST = 'MARK_BOARDGAME_AS_SELECTION_REQUEST';
const MARK_BOARDGAME_AS_SELECTION_SUCCESS = 'MARK_BOARDGAME_AS_SELECTION_SUCCESS';
const MARK_BOARDGAME_AS_SELECTION_FAILED = 'MARK_BOARDGAME_AS_SELECTION_FAILED';

const SET_BOARDGAME_VISIBILITY_REQUEST = 'SET_BOARDGAME_VISIBILITY_REQUEST';
const SET_BOARDGAME_VISIBILITY_SUCCESS = 'SET_BOARDGAME_VISIBILITY_SUCCESS';
const SET_BOARDGAME_VISIBILITY_FAILED = 'SET_BOARDGAME_VISIBILITY_FAILED';

const GET_BOARDGAME_STATISTICS_REQUEST = 'GET_BOARDGAME_STATISTICS_REQUEST';
const GET_BOARDGAME_STATISTICS_SUCCESS = 'GET_BOARDGAME_STATISTICS_SUCCESS';
const GET_BOARDGAME_STATISTICS_FAILED = 'GET_BOARDGAME_STATISTICS_FAILED';

const GET_GALLERY_FOR_BOARDGAME_REQUEST = 'GET_GALLERY_FOR_BOARDGAME_REQUEST';
const GET_GALLERY_FOR_BOARDGAME_SUCCESS = 'GET_GALLERY_FOR_BOARDGAME_SUCCESS';
const GET_GALLERY_FOR_BOARDGAME_FAILED = 'GET_GALLERY_FOR_BOARDGAME_FAILED';

const fetchVisibleBoardgamesRequest = createAction(FETCH_VISIBLE_BOARDGAMES_REQUEST);
const fetchVisibleBoardgamesSuccess = createAction(FETCH_VISIBLE_BOARDGAMES_SUCCESS);

const fetchBoardgamesRequest = createAction(FETCH_BOARDGAMES_REQUEST);
const fetchBoardgamesSuccess = createAction(FETCH_BOARDGAMES_SUCCESS);
const fetchBoardgamesFailed = createAction(FETCH_BOARDGAMES_FAILED);

const reserveBoardgameRequest = createAction(RESERVE_BOARDGAME_REQUEST);
const reserveBoardgameSuccess = createAction(RESERVE_BOARDGAME_SUCCESS);
const reserveBoardgameFailed = createAction(RESERVE_BOARDGAME_FAILED);

const getBackBoardgameRequest = createAction(GET_BACK_BOARDGAME_REQUEST);
const getBackBoardgameSuccess = createAction(GET_BACK_BOARDGAME_SUCCESS);
const getBackBoardgameFailed = createAction(GET_BACK_BOARDGAME_FAILED);

const getBackAllBoardgamesRequest = createAction(GET_BACK_ALL_BOARDGAMES_REQUEST);
const getBackAllBoardgamesSuccess = createAction(GET_BACK_ALL_BOARDGAMES_SUCCESS);
const getBackAllBoardgamesFailed = createAction(GET_BACK_ALL_BOARDGAMES_FAILED);

const createBoardgameRequest = createAction(CREATE_BOARDGAME_REQUEST);
const createBoardgameSuccess = createAction(CREATE_BOARDGAME_SUCCESS);
const createBoardgameFailed = createAction(CREATE_BOARDGAME_FAILED);

const getBoardgameRequest = createAction(GET_BOARDGAME_REQUEST);
const getBoardgameSuccess = createAction(GET_BOARDGAME_SUCCESS);
const getBoardgameFailed = createAction(GET_BOARDGAME_FAILED);

const updateBoardgameRequest = createAction(UPDATE_BOARDGAME_REQUEST);
const updateBoardgameSuccess = createAction(UPDATE_BOARDGAME_SUCCESS);
const updateBoardgameFailed = createAction(UPDATE_BOARDGAME_FAILED);

const markBoardgameAsSelectionRequest = createAction(MARK_BOARDGAME_AS_SELECTION_REQUEST);
const markBoardgameAsSelectionSuccess = createAction(MARK_BOARDGAME_AS_SELECTION_SUCCESS);
const markBoardgameAsSelectionFailed = createAction(MARK_BOARDGAME_AS_SELECTION_FAILED);

const setBoardgameVisibilityRequest = createAction(SET_BOARDGAME_VISIBILITY_REQUEST);
const setBoardgameVisibilitySuccess = createAction(SET_BOARDGAME_VISIBILITY_SUCCESS);
const setBoardgameVisibilityFailed = createAction(SET_BOARDGAME_VISIBILITY_FAILED);

const getBoardgameStatisticsRequest = createAction(GET_BOARDGAME_STATISTICS_REQUEST);
const getBoardgameStatisticsSuccess = createAction(GET_BOARDGAME_STATISTICS_SUCCESS);
const getBoardgameStatisticsFailed = createAction(GET_BOARDGAME_STATISTICS_FAILED);

const getGalleryForBoardgameRequest = createAction(GET_GALLERY_FOR_BOARDGAME_REQUEST);
const getGalleryForBoardgameSuccess = createAction(GET_GALLERY_FOR_BOARDGAME_SUCCESS);
const getGalleryForBoardgameFailed = createAction(GET_GALLERY_FOR_BOARDGAME_FAILED);

let _unsubscribeBgSnapshot = null;

export const subscribeToVisibleBoardgames = (orderBy = 'title') => {
  return dispatch => {
    if (_unsubscribeBgSnapshot) {
      _unsubscribeBgSnapshot();
    }
  
    dispatch(fetchVisibleBoardgamesRequest());

    const constraints = [
      where('visible', '==', true),
    ];

    if (orderBy === 'title') {
      constraints.push(ob('title'));
    } else if (orderBy === 'popularity') {
      constraints.push(ob('playsCount', 'desc'));
      constraints.push(ob('title'));
    }

    const q = query(
      collection(db, "boardgames"),
      ...constraints
    );

    _unsubscribeBgSnapshot = onSnapshot(q, (snapshot) => {
        const boardgames = snapshot.docs.map(doc => Object.assign({}, { id: doc.id }, doc.data()));
        dispatch(fetchVisibleBoardgamesSuccess({ ...normalize(boardgames, boardgamesSchema) }));
    });
  };
};

export const unsubscribeToVisibleBoardgames = () => {
  return dispatch => {
    if (_unsubscribeBgSnapshot) {
      _unsubscribeBgSnapshot();
    }
  };
};

export const getAllBoardgames = () => {
  return dispatch => {
    dispatch(fetchBoardgamesRequest());
    
    const q = query(
      collection(db, "boardgames"),
      ob('title', 'asc')
    );

    getDocs(q)
      .then(snapshot => {
        const boardgames = snapshot.docs.map(doc => Object.assign({}, { id: doc.id }, doc.data()));
        dispatch(fetchBoardgamesSuccess({ ...normalize(boardgames, boardgamesSchema) }));
      })
      .catch(error => {
        dispatch(fetchBoardgamesFailed({ 
          notie: { type: 'error', message: error },
        }));
      });
  };
};

export const reserveBoardgame = (id) => {
  return dispatch => {

    dispatch(reserveBoardgameRequest());

    const boardgameDocRef = doc(db, 'boardgames', id);

    runTransaction(db, async transaction => {
      const document = await transaction.get(boardgameDocRef);
      if (!document.exists()) {
        throw Error("Il gioco non esiste.");
      }

      if (document.data().reservedCopies === document.data().availableCopies) {
        // eslint-disable-next-line
        throw Error("Il gioco non può essere riservato!");
      }

      const reservedCopies = (document.data().reservedCopies || 0) + 1;
      const playsCount = (document.data().playsCount || 0) + 1;
      transaction.update(boardgameDocRef, { reservedCopies, playsCount });
    })
    .then(() => {
      dispatch(reserveBoardgameSuccess({
        notie: { type: 'success', message: 'Titolo riservato correttamente!' },
      }));
    })
    .catch(error => {
      dispatch(reserveBoardgameFailed({
        notie: { type: 'error', message: error },
      }));
    });
  };
};

export const getBackBoardgame = (id) => {
  return dispatch => {
    dispatch(getBackBoardgameRequest());

    const boardgameDocRef = doc(db, 'boardgames', id);

    runTransaction(db, async transaction => {
      const document = await transaction.get(boardgameDocRef);
      if (!document.exists()) {
        throw Error("Il gioco non esiste.");
      }

      debugger

      if (document.data().reservedCopies === 0) {
        // eslint-disable-next-line
        throw Error("Tutte le copie sono già disponibili!");
      }

      const reservedCopies = document.data().reservedCopies - 1;
      transaction.update(boardgameDocRef, { reservedCopies });
    })
    .then(() => {
      dispatch(getBackBoardgameSuccess({
        notie: { type: 'success', message: 'Titolo restituito correttamente!' },
      }));
    })
    .catch(error => {
      dispatch(getBackBoardgameFailed({
        notie: { type: 'error', message: error },
      }));
    });
  };
};

export const getBackAllBoardgames = (ids = []) => {
  return dispatch => {
    dispatch(getBackAllBoardgamesRequest());

    const batch = writeBatch(db);
      ids.forEach(id => {
        batch.update(
          doc(db, 'boardgames', id),
          { reservedCopies: 0 }
        );
      });

      batch.commit()
        .then(() => {
          dispatch(getBackAllBoardgamesSuccess({
            notie: { type: 'success', message: 'Tutti i giochi sono stati restituiti!' },
          }));
        })
        .catch(error => {
          dispatch(getBackAllBoardgamesFailed({
            notie: { type: 'error', message: error },
          }));
        });
  };
};

export const getBoardgame = (id, onlyVisible = false) => {
  return dispatch => {
    dispatch(getBoardgameRequest());

    getDoc(
        doc(db, 'boardgames', id)
      )
      .then(document => {
        const boardgame = document.exists()
          ? Object.assign({}, { id: document.id }, document.data())
          : {};

        dispatch(getBoardgameSuccess({
          ...normalize(boardgame, boardgameSchema)
        }));
      })
      .catch(error => {
        dispatch(getBoardgameFailed({
          notie: { type: 'error', message: error },
        }));
      });
  };
};

export const createBoardgame = (bg) => {
  return dispatch => {
    dispatch(createBoardgameRequest());

    addDoc(
        collection(db, 'boardgames'),
        bg
      )
      .then(ref => Object.assign({}, { id: ref.id }, bg))
      .then(boardgame => {
        dispatch(createBoardgameSuccess( { ...normalize(boardgame, boardgameSchema) }))
        dispatch(push('/admin/boardgames'));
      })
      .catch(error => dispatch(createBoardgameFailed({
        notie: { type: 'error', message: error },
      })));
  };
};

export const updateBoardgame = (id, bg) => {
  return dispatch => {
    dispatch(updateBoardgameRequest());

    const data = pick([
      'title', 'description', 'availableCopies',
      'minPlayers', 'maxPlayers',
      'minPlayTime', 'maxPlayType',
      'bggId', 'thumbnail', 'image', 'categories',
      'articles',
    ], bg);

    updateDoc(
        doc(db, 'boardgames', id),
        data
      )
      .then(() => {
        dispatch(updateBoardgameSuccess( { ...normalize(bg, boardgameSchema) }))
        dispatch(push('/admin/boardgames'));
      })
      .catch(error => dispatch(updateBoardgameFailed({
        notie: { type: 'error', message: error },
      })));
  };
};

export const markBoardgameAsSelection = (bg, selection) => {
  return dispatch => {
    dispatch(markBoardgameAsSelectionRequest());
    
    updateDoc(
        doc(db, 'boardgames', bg.id),
        { selection }
      )
      .then(() => {
        const boardgame = Object.assign({}, bg, { selection });
        dispatch(markBoardgameAsSelectionSuccess({
          ...normalize(boardgame, boardgameSchema)
        }));
      })
      .catch(error => dispatch(markBoardgameAsSelectionFailed({
        notie: { type: 'error', message: error },
      })));
  };
};

export const setBoardgameVisibility = (bg, visible) => {
  return dispatch => {
    dispatch(setBoardgameVisibilityRequest());

    const data  = { visible };
    if (!visible) {
      data.selection = false;
    }

    updateDoc(
        doc(db, 'boardgames', bg.id),
        data
      )
      .then(() => {
        const boardgame = Object.assign({}, bg, data);
        dispatch(setBoardgameVisibilitySuccess({
          ...normalize(boardgame, boardgameSchema)
        }));
      })
      .catch(error => dispatch(setBoardgameVisibilityFailed({
        notie: { type: 'error', message: error },
      })));
  };
};

export const getBoardgameStatistics = (id) => {
  return dispatch => {
    dispatch(getBoardgameStatisticsRequest());
    const q = query(
      collection(db, 'boardgames', id, 'series'),
      ob('day', 'asc'),
      limit(7)
    )
    getDocs(q)
      .then(snapshot => {
        const statistics = snapshot.docs.map(doc => Object.assign({}, { id: doc.id }, doc.data()));
        dispatch(getBoardgameStatisticsSuccess({ id, ...normalize(statistics, statisticsSchema) }));
      })
      .catch(error => dispatch(getBoardgameStatisticsFailed({
        notie: { type: 'error', message: error },
      })));
  };
};

export const getGalleryForBoardgame = (id, bggId, page, limit) => {
  return dispatch => {
    dispatch(getGalleryForBoardgameRequest());

    BggService.getGalleryForId(bggId, page, limit)
      .then(response => {
        response.images = pathOr([], ['images'], response).map((image, index) => ({
          id: image.imageid,
          photo: image.imageurl_lg,
          thumbnail: image.imageurl,
          caption: image.caption,
          number: ((page - 1) * limit) + index + 1,
          subcaption: 'Credits www.boardgamegeek.com',
        }));
        dispatch(getGalleryForBoardgameSuccess({ id, page, limit, data: response }));
      })
      .catch(error => dispatch(getGalleryForBoardgameFailed({
        notie: { type: 'error', message: error },
      })));
  };
};

export const actions = {
  FETCH_VISIBLE_BOARDGAMES_REQUEST,
  FETCH_VISIBLE_BOARDGAMES_SUCCESS,
  FETCH_VISIBLE_BOARDGAMES_FAILED,
  FETCH_BOARDGAMES_REQUEST,
  FETCH_BOARDGAMES_SUCCESS,
  FETCH_BOARDGAMES_FAILED,
  RESERVE_BOARDGAME_REQUEST,
  RESERVE_BOARDGAME_SUCCESS,
  RESERVE_BOARDGAME_FAILED,
  GET_BACK_BOARDGAME_REQUEST,
  GET_BACK_BOARDGAME_SUCCESS,
  GET_BACK_BOARDGAME_FAILED,
  GET_BACK_ALL_BOARDGAMES_REQUEST,
  GET_BACK_ALL_BOARDGAMES_SUCCESS,
  GET_BACK_ALL_BOARDGAMES_FAILED,
  CREATE_BOARDGAME_REQUEST,
  CREATE_BOARDGAME_SUCCESS,
  CREATE_BOARDGAME_FAILED,
  GET_BOARDGAME_REQUEST,
  GET_BOARDGAME_SUCCESS,
  GET_BOARDGAME_FAILED,
  UPDATE_BOARDGAME_REQUEST,
  UPDATE_BOARDGAME_SUCCESS,
  UPDATE_BOARDGAME_FAILED,
  MARK_BOARDGAME_AS_SELECTION_REQUEST,
  MARK_BOARDGAME_AS_SELECTION_SUCCESS,
  MARK_BOARDGAME_AS_SELECTION_FAILED,
  SET_BOARDGAME_VISIBILITY_REQUEST,
  SET_BOARDGAME_VISIBILITY_SUCCESS,
  SET_BOARDGAME_VISIBILITY_FAILED,
  GET_BOARDGAME_STATISTICS_REQUEST,
  GET_BOARDGAME_STATISTICS_SUCCESS,
  GET_BOARDGAME_STATISTICS_FAILED,
  GET_GALLERY_FOR_BOARDGAME_REQUEST,
  GET_GALLERY_FOR_BOARDGAME_SUCCESS,
  GET_GALLERY_FOR_BOARDGAME_FAILED,
};